// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DateFns from "../utils/DateFns.bs.js";
import * as Js_array from "../../../../node_modules/rescript/lib/es6/js_array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";

function id(t) {
  return t.id;
}

function name(t) {
  return t.name;
}

function avatarUrl(t) {
  return t.avatarUrl;
}

function fullTitle(t) {
  return t.fullTitle;
}

function lastSeenAt(t) {
  return t.lastSeenAt;
}

function taggings(t) {
  return t.taggings;
}

function affiliation(t) {
  return t.affiliation;
}

function title(t) {
  return t.title;
}

var Raw = {};

function parse(value) {
  var value$1 = value.affiliation;
  var value$2 = value.avatarUrl;
  var value$3 = value.taggings;
  var value$4 = value.lastSeenAt;
  return {
          id: value.id,
          name: value.name,
          title: value.title,
          affiliation: !(value$1 == null) ? value$1 : undefined,
          fullTitle: value.fullTitle,
          avatarUrl: !(value$2 == null) ? value$2 : undefined,
          taggings: Js_array.map((function (value) {
                  return value;
                }), value$3),
          lastSeenAt: !(value$4 == null) ? Caml_option.some(value$4) : undefined
        };
}

function serialize(value) {
  var value$1 = value.lastSeenAt;
  var lastSeenAt = value$1 !== undefined ? Caml_option.valFromOption(value$1) : null;
  var value$2 = value.taggings;
  var taggings = Js_array.map((function (value) {
          return value;
        }), value$2);
  var value$3 = value.avatarUrl;
  var avatarUrl = value$3 !== undefined ? value$3 : null;
  var value$4 = value.fullTitle;
  var value$5 = value.affiliation;
  var affiliation = value$5 !== undefined ? value$5 : null;
  var value$6 = value.title;
  var value$7 = value.name;
  var value$8 = value.id;
  return {
          id: value$8,
          name: value$7,
          title: value$6,
          affiliation: affiliation,
          fullTitle: value$4,
          avatarUrl: avatarUrl,
          taggings: taggings,
          lastSeenAt: lastSeenAt
        };
}

function verifyArgsAndParse(_UserDetailsFragment, value) {
  return parse(value);
}

function verifyName(param) {
  
}

var Fragment = {
  Raw: Raw,
  query: "fragment UserDetailsFragment on User   {\nid  \nname  \ntitle  \naffiliation  \nfullTitle  \navatarUrl  \ntaggings  \nlastSeenAt  \n}\n",
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};

function makeFromFragment(user) {
  return {
          id: user.id,
          name: user.name,
          title: user.title,
          affiliation: user.affiliation,
          fullTitle: user.fullTitle,
          avatarUrl: user.avatarUrl,
          taggings: user.taggings,
          lastSeenAt: Belt_Option.map(user.lastSeenAt, DateFns.decodeISO)
        };
}

function makeFromJs(jsObject) {
  return {
          id: jsObject.id,
          name: jsObject.name,
          title: jsObject.title,
          affiliation: jsObject.affiliation,
          fullTitle: jsObject.fullTitle,
          avatarUrl: jsObject.avatarUrl,
          taggings: jsObject.taggings,
          lastSeenAt: Belt_Option.map(jsObject.lastSeenAt, DateFns.decodeISO)
        };
}

export {
  id ,
  name ,
  avatarUrl ,
  fullTitle ,
  lastSeenAt ,
  taggings ,
  affiliation ,
  title ,
  Fragment ,
  makeFromFragment ,
  makeFromJs ,
}
/* DateFns Not a pure module */
